/**
 * View component for /site-locations
 *
 * Generic siteLocation list view. Defaults to 'all' with:
 * this.props.dispatch(siteLocationActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as siteLocationActions from '../siteLocationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import siteLocation components
import SiteLocationLayout from '../components/SiteLocationLayout.js.jsx';
import SiteLocationListItem from '../components/SiteLocationListItem.js.jsx';

// import siteLocation css modules
import siteLocationStyles from '../siteLocationModuleStyles.css';

class SiteLocationList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(siteLocationActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { siteLocationStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the siteLocationList meta info here so we can reference 'isFetching'
    const siteLocationList = siteLocationStore.lists ? siteLocationStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual siteLocation objetcs
     */
    const siteLocationListItems = siteLocationStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !siteLocationListItems || !siteLocationList;

    return (
      <SiteLocationLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Site/Team Location List
                <Link className="yt-btn small u-pullRight" to={'/site-locations/new'}> NEW Site/Team Location </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (siteLocationListItems && siteLocationList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: siteLocationList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {siteLocationListItems.map((siteLocation, i) =>
                      <SiteLocationListItem key={siteLocation._id + i} siteLocation={siteLocation} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </SiteLocationLayout>
    )
  }
}

SiteLocationList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    siteLocationStore: store.siteLocation
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SiteLocationList)
);



// WEBPACK FOOTER //
// modules/siteLocation/views/SiteLocationList.js.jsx